module.exports = __webpack_public_path__ + "static/media/wineGlass.2ac7384f.svg";